import { Button } from "@dropbox/dig-components/buttons";
import { Modal } from "@dropbox/dig-components/modal";
import { DashThemeProvider } from "@mirage/service-settings/theming/DashThemeProvider";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import i18n from "@mirage/translations";
import classnames from "classnames";
import { memo, useRef } from "react";
import { AddSourcesContent } from "./AddSourcesContent";
import styles from "./AddSourcesModal.module.css";

import type { AddSourcesContentProps } from "./AddSourcesContent";

type AddSourcesModalProps = AddSourcesContentProps;

export const AddSourcesModal = memo(
  ({
    sources,
    sourcesContentCache,
    addSource,
    removeSource,
    onRequestClose,
    logComposeEvent,
  }: AddSourcesModalProps) => {
    const isMobile = useIsMobileSize();
    const modalContentRef = useRef<HTMLDivElement>(null);

    return (
      <Modal
        open
        width={694}
        isCentered
        onRequestClose={onRequestClose}
        withCloseButton="close"
        className={styles.AddSourcesModalWindow}
      >
        <DashThemeProvider>
          <Modal.Body
            ref={modalContentRef}
            className={classnames(
              styles.AddSourcesModalBody,
              isMobile && styles.AddSourcesModalBodyMobile,
            )}
          >
            <AddSourcesContent
              sources={sources}
              sourcesContentCache={sourcesContentCache}
              addSource={addSource}
              removeSource={removeSource}
              onRequestClose={onRequestClose}
              logComposeEvent={logComposeEvent}
            />
            <div className={styles.AddSourcesModalFooter}>
              <Button size="large" variant="primary" onClick={onRequestClose}>
                {i18n.t("done")}
              </Button>
            </div>
          </Modal.Body>
        </DashThemeProvider>
      </Modal>
    );
  },
);

AddSourcesModal.displayName = "AddSourcesModal";
